import { Constants } from './../../constant';
import { Component, OnInit, Inject, Renderer2, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AccessibilityService } from '../../service/accessibility.service';
import { SidebarService } from '../../service/sidebar.service';
import { DOCUMENT, Location } from '@angular/common';
import { Title } from "@angular/platform-browser";

//import { AccessibilityService, ConfigService, DictionaryService } from '../shared';

@Component({
  selector: 'elect-settings',
  templateUrl: 'settings.component.html',
  styleUrls: [
    'settings.component.scss',
    'settings.component.hc.scss'
  ]
})
export class SettingsComponent implements OnInit, AfterViewInit {

  return: Observable<string>;
  returnPath: string;
  returnParams: { [key: string]: string };
  @ViewChild('startFocus') startFocus: ElementRef;

  constructor(
    private accessibilityService: AccessibilityService,
    //private _config: ConfigService,
    //private _dictionaryService: DictionaryService,
    private route: ActivatedRoute,
    private router: Router,
    private sidebarService: SidebarService,
    private titleService: Title,
    private renderer: Renderer2,
    private location: Location,
    @Inject(DOCUMENT) private _document: any
  ) {

    this.titleService.setTitle("Display Settings - 2026 CAPE Contract Ratification");
  }

  ngOnInit() {
    const docClasses: DOMTokenList = this._document.documentElement.classList;
    docClasses.remove('blackout-screen');
  }

  ngAfterViewInit() {
    //this.startFocus.nativeElement.focus();
  }

  get currentTextSize(): string {
    return this.accessibilityService.current.textSize;
  }

  setTextSize(textSize: string) {
    this.accessibilityService.setTextSize(textSize);
  }

 
  get blackoutActive(): boolean {
    return this.accessibilityService.current.blackout;
  }
  toggleBlackout() {
    this.accessibilityService.setBlackout(!this.accessibilityService.current.blackout);
  }

  get activeContrast(): string {
    return this.accessibilityService.current.contrast;
  }

  setContrast(contrast: string) {
    this.accessibilityService.setContrast(contrast);
  }

  returnToBallot() {
    this.location.back()
    }
}



// WEBPACK FOOTER //
// ./src/app/features/settings/settings.component.ts